exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview.select-item[data-v-718cc3a7]{border:1px solid #fff;cursor:pointer}", ""]);

// exports
